import { apiSlice } from '@src/services/api/apiSlice';
import { UpdateUserParams } from './updateUserApiSliceTypes';
import { User } from '../usersTypes';

const updateUserApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        updateUser: builder.mutation<User, UpdateUserParams>({
            query: (params) => {
                const { id, ...rest } = params;
                return {
                    url: `/users/${id}`,
                    method: 'PATCH',
                    body: { ...rest },
                };
            },
            invalidatesTags: [{ type: 'users', id: 'LIST' }],
        }),
    }),
    overrideExisting: true,
});

export const { useUpdateUserMutation } = updateUserApiSlice;
